import { parse } from "query-string";
import React from "react";

import { TopicModeratorsList } from "@/mk2/apps/forum/components/TopicModeratorsList";
import { Props } from "@/mk2/apps/forum/containers/TopicInfo/TopicInfoPage";
import { RenderSnippetAs } from "@/mk2/apps/wiki/utils";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { astToHtml, defaultFilterAdditionalData } from "@/mk2/helpers/article_ast/filters";
import { cacheLast } from "@/mk2/helpers/cache";
import {
    FORUM_TOPIC_DID_NOT_FIND_YOUR_MODERATOR_INVITATION_FOR_THIS_TOPIC,
    THIS_TOPIC_HAS_NO_DESCRIPTION,
    TOPIC_DESCRIPTION_AND_RULES,
    TOPIC_MODERATORS,
} from "@/mk/autogenerated/translation";

import styles from "./TopicInfo.mscss";

class TopicInfo extends React.Component<Props> {
    private astToHtmlCache = cacheLast(true);

    public render() {
        const { loadingState, topic } = this.props;

        return (
            <div className={styles.TopicInfo}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={!!topic}
                />
            </div>
        );
    }

    public componentDidMount() {
        const { onErrorToast } = this.props;
        const query = parse(this.props.location.search) || {};

        if (query.noInvitation === "true") {
            onErrorToast(FORUM_TOPIC_DID_NOT_FIND_YOUR_MODERATOR_INVITATION_FOR_THIS_TOPIC);
        }
    }

    private load = () => {
        const {
            routeParams: { topicSlug },
            onLoad,
        } = this.props;
        onLoad(topicSlug);
    };

    private renderLoadSuccess = () => {
        const {
            topic,
            requestUser,
            requestUserPermissions,
            onInviteModerator,
            onRemoveModerator,
            onDeclineInvitation,
        } = this.props;

        let bodyChunks: React.ReactChild[] = null;
        if (topic?.descriptionAST) {
            const additionalData = {
                ...defaultFilterAdditionalData,
                linkedObjects: topic.descriptionASTAdditionalData
                    ? topic.descriptionASTAdditionalData.linkedObjects
                    : {},
                renderSpecialWikiLinks: false,
                renderSnippetObjectsAs: RenderSnippetAs.HTML_IFRAME,
                rootDiv: false,
            };
            bodyChunks = this.astToHtmlCache(
                () => astToHtml(topic.descriptionAST, additionalData),
                topic.descriptionAST,
            );
        }

        return (
            <div>
                <div className={styles.TopicInfo__rules}>
                    <div className={styles.TopicInfo__rules__heading}>
                        {TOPIC_DESCRIPTION_AND_RULES}
                    </div>
                    {!topic.descriptionAST ? (
                        <div className={styles.TopicInfo__rules__no_rules}>
                            {THIS_TOPIC_HAS_NO_DESCRIPTION}
                        </div>
                    ) : (
                        <div>{bodyChunks}</div>
                    )}
                </div>

                <div className={styles.TopicInfo__moderators}>
                    <div className={styles.TopicInfo__moderators__heading}>{TOPIC_MODERATORS}</div>
                    <TopicModeratorsList
                        requestUser={requestUser}
                        requestUserPermissions={requestUserPermissions}
                        topic={topic}
                        moderatorsDetails={this.props.moderatorsDetails}
                        onInviteModerator={onInviteModerator}
                        onRemoveModerator={onRemoveModerator}
                        onDeclineInvitation={onDeclineInvitation}
                    />
                </div>
            </div>
        );
    };
}

export default TopicInfo;
